import * as React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getArticleDetail, getArticleDetailSuccess } from './actions'
import { updateFavoriteArticle } from '../../actions'
import { getFavoriteListSuccess } from '../../components/Header/actions'
import * as moment from 'moment'
import { Modal, Menu, Dropdown, Button } from 'antd'
import { CSVLink } from 'react-csv';
import 'antd/dist/antd.css'
import './index.css'
class ArticleDetail extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            loadMore: true,
            columns: [],
            visible: false,
            currentTable: [],
            currentTableIndex: 0,
            imageVisible: false,
            currentImage: '',
            currentImageIndex: 0
        }
        this.goTo = this.goTo.bind(this)
        this.updateFavoriteState = this.updateFavoriteState.bind(this)
    }
    componentDidMount() {
        this.props.getArticleDetail(this.props.match.params.id)
    }

    getMoreContent() {
        this.setState({
            loadMore: !this.state.loadMore
        })
    }

    goTo(url: string) {
        window.open(url, '_blank')
    }

    updateFavoriteState(action: string) {
        const newDetail = {
            ...this.props.detail.entities, 
            enable_favorites: !this.props.detail.entities.enable_favorites
        } 
        this.props.fetchedArticleDetail(newDetail)

        const data = {
            action: action,
            favorites_list: this.props.match.params.id
        }
        this.props.updateFavoriteArticle(data)
        if (this.props.favoriteList.entities) {
            let favorites = this.props.favoriteList.entities
            if (action === 'add') {
                favorites.push(
                    {
                        id: this.props.match.params.id,
                        title: this.props.detail.entities.article_title
                    }
                )
            } else {
                for (let i = 0; i < favorites.length; i++) {
                    if (favorites[i].title === this.props.detail.entities.article_title) {
                        favorites.splice(i, 1)
                    }
                }

            }
            this.props.fetchFavoriteList(favorites)
        }
    }
    showTableOnWindow(table: any, index: any) {
        this.setState({
            visible: true,
            currentTable: table,
            currentTableIndex: index + 1
        })
    }
    handleOk() {
        this.setState({
            visible: false,
            imageVisible: false,
        })
    }
    handleCancel() {
        this.setState({
            visible: false,
            imageVisible: false,
        })
    }
    showImageOnModel(image: any, i: number) {
        this.setState(
            {
                imageVisible: true,
                currentImage: image,
                currentImageIndex: i + 1
            }
        )
    }

    render() {
        const detail = this.props.detail.entities
        const currentTable = this.state.currentTable
        const reportName = ['查看报告正文', '查看报告全文']
        const menu = (
            <Menu>
                {
                    detail.attachment_url && detail.attachment_url.length >= 2 && detail.attachment_url.map((url: any, i: number) =>
                    <Menu.Item key={i}>
                    {/*<a onClick={() => this.goTo(url)}>查看PDF{i}</a>*/}
                        <a target="_blank" rel="noopener noreferrer" href={url}>{reportName[i]}</a>
                    </Menu.Item>
                    )
                }
            </Menu>
        )
        return (
            <div className="article-detail grow">
                <Helmet title="研报详情 - 投研通"/>
                <div className="detail-header">
                    <div className="detail-header-container">
                        <div className="detail-title">
                            {detail.article_title}
                        </div>

                        <div className="detail-subtitle">
                            {
                                detail.authors && detail.authors.length > 0 && detail.authors.map((author: any, index: number) =>
                                    <div className="item detail-author" key={author.sec_id}>
                                        <Link to={`/author/${author.sec_id}`} >
                                            {author.analyst_name}
                                        </Link>
                                    </div>
                                )
                            }
                            <div className="item">
                                {detail.category}
                            </div>
                            {
                                detail.create_time &&
                                <div className="item">
                                    {moment(parseInt(detail.create_time, 10)).format('YYYY.MM.DD')}
                                </div>
                            }
                        </div>

                        <div className="detail-links">
                            {
                                detail.attachment_url && detail.attachment_url.length >= 2 ?
                                    <div className="dropDownMenu">
                                    <Dropdown overlay={menu} placement="bottomLeft" >
                                    <Button className="item">
                                        <i className="fa fa-file-pdf-o"/>
                                        查看PDF{detail.pages ? '(' + detail.pages + '页)' : ''}</Button>
                                    </Dropdown>
                                    </div>
                                    :
                                    <div className="item">
                                        <div onClick={() => this.goTo(detail.attachment_url[0])}>
                                            <i className="fa fa-file-pdf-o"/>
                                            查看PDF{detail.pages ? '(' + detail.pages + '页)' : ''}
                                        </div>
                                    </div>
                            }

                            {
                                detail.article_url &&
                                <div className="item">
                                    <div onClick={() => this.goTo(detail.article_url)}>
                                        <i className="fa fa-external-link"/>
                                        查看原文链接
                                    </div>
                                </div>
                            }
                            <div className="item">
                                {
                                    detail.enable_favorites ?
                                    <div onClick={() => this.updateFavoriteState('delete')}>
                                        <i className="fa fa-bookmark"/>
                                        已收藏
                                    </div> :
                                    <div onClick={() => this.updateFavoriteState('add')}>
                                        <i className="fa fa-bookmark-o"/>
                                        添加收藏
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="detail-content">
                    {
                        detail.article_content &&
                        <div className="article">
                            <div className="title">
                                报告摘要
                            </div>
                            {
                                this.state.loadMore ?
                                (detail.article_content.split('\n').length > 3 ? detail.article_content.split('\n').slice(0, 3).map((i: any, index: number) => {
                                    return <p key={index} dangerouslySetInnerHTML={{__html: i}} />
                                }) :
                                    detail.article_content.split('\n').map((i: any, index: number) => {
                                    return <p key={index} dangerouslySetInnerHTML={{__html: i}} />
                                })) :
                                detail.article_content.split('\n').map((i: any, index: number) => {
                                    return <p key={index} dangerouslySetInnerHTML={{__html: i}} />
                                })
                            }
                            <span className="load-more" onClick={() => this.getMoreContent()}>
                                {this.state.loadMore ? '(更多)' : '(收起)'}
                            </span>
                        </div>
                    }
                    {
                        detail.attachment_content && detail.attachment_content.length &&
                        <div className="tables-content">
                            <div className="title">
                                报告提取图表
                            </div>
                            <div className="tables">
                            {
                                detail.attachment_content.map((table: any, i: number) =>
                                    <div className="table-box" key={'table-' + i}>
                                        <div className="table-title">
                                              表 {i + 1 + ' ' + table[0]}
                                         </div>
                                       <div className="table-row" onClick={() => this.showTableOnWindow(table, i)} >
                                           <table className="table">
                                             <tbody>
                                             {
                                            table.slice(1, table.length).map((row: any, i: number) =>
                                                <tr className="row" key={'row-' + i}>
                                                    {
                                                        row.map((item: any, i: number) =>
                                                            <td colSpan={item.colspan} rowSpan={item.rowspan} className={'col ' + (item.value === 'ph_l' ? 'delete-border-left' : '') + (item.value === 'ph_u' ? 'delete-border-top' : '')} key={'col-' + i} title={item.value}>
                                                                {item.value ? (item.value === 'ph_l' || item.value === 'ph_u' ? '' : item.value) : ' '}
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                             )
                                            }
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                )
                            }
                            </div>
                            {
                                detail.images &&
                                <div className="tables">
                                    {
                                        detail.images.map((image: any, i: any) =>
                                            <div className="table-box" key={'table-' + i}>
                                                <div className="table-title">
                                                    图 {i + 1}
                                                </div>
                                                <div className="table-row">
                                                   <div className="image-box" onClick={() => this.showImageOnModel(image, i)} style={{backgroundImage: 'url(' + image + ')'}}/>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            }

                        </div>
                    }
                </div>
                <Modal title={'表' + this.state.currentTableIndex + ' ' + currentTable[0]} visible={this.state.visible} onOk={() => this.handleOk()} onCancel={() => this.handleCancel()} footer={null}>
                        <table className="model-table" key={'table'}>
                            <tbody>
                            {
                                currentTable.length > 0 && currentTable.slice(1, currentTable.length).map((row: any, i: number) =>
                                    <tr className="model-row" key={'row-' + i}>
                                        {
                                            row.map((item: any, i: number) =>
                                                <td colSpan={item.colspan} rowSpan={item.rowspan} className={'model-col ' + (item.value === 'ph_l' ? 'delete-border-left' : '') + (item.value === 'ph_u' ? 'delete-border-top' : '')}  key={'col-' + i} >
                                                    {item.value ? (item.value === 'ph_l' || item.value === 'ph_u' ? '' : item.value) : ' '}
                                                </td>
                                            )
                                        }
                                    </tr>
                                )
                            }
                            </tbody>
                        </table>
                    <div className="downloadCsv">
                        <Button><CSVLink data={currentTable.slice(1, currentTable.length)}>下载表格(csv文件)</CSVLink></Button>
                    </div>
                </Modal>
                <Modal title={'图' + this.state.currentImageIndex} visible={this.state.imageVisible} onOk={() => this.handleOk()} onCancel={() => this.handleCancel()} footer={null}>

                   <div>
                       <div className="image-model" style={{backgroundImage: 'url(' + this.state.currentImage + ')'}}/>
                   </div>
                    <div className="downloadCsv">
                        <Button><a href={this.state.currentImage} download={this.state.currentImage}>下载原图</a></Button>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        detail: state.articleDetail,
        favoriteList: state.favoriteList
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getArticleDetail: (data: object) => dispatch(getArticleDetail(data)),
        fetchedArticleDetail: (data: object) => dispatch(getArticleDetailSuccess(data)),
        fetchFavoriteList: (data: object) => dispatch(getFavoriteListSuccess(data)),
        updateFavoriteArticle: (data: object) => dispatch(updateFavoriteArticle(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleDetail)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/ArticleDetail/index.tsx